import { DEFAULT_LOCALE, type Locale } from "./config";
import { splitLocale } from "./paths";

// Idioma de la página actual, para requests desde el navegador (el backend
// responde errores, y guarda el idioma de los correos, según esto). En el
// servidor no hay URL a mano: cada página pasa su `lang` explícito.
export function currentLocale(): Locale {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  return splitLocale(window.location.pathname).lang ?? DEFAULT_LOCALE;
}

// El backend solo acepta un idioma exacto ("es", "en") — el Accept-Language
// que el navegador manda solo ("en-US,en;q=0.9") lo ignora a propósito.
export function localeHeaders(lang: Locale = currentLocale()): Record<string, string> {
  return { "Accept-Language": lang };
}
